import Image from "next/image";
import Link from "next/link";
import { FaUserGraduate, FaChalkboardTeacher, FaBook, FaUniversity } from "react-icons/fa";
import { motion } from "framer-motion";

const HeroSection = () => {
  return (
    <section className="relative w-full bg-[#005F59] py-24 px-6 text-center overflow-hidden flex flex-col items-center">
      {/* Background Pattern */}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <Image
          src="/assets/pattern.svg"
          alt="Background Pattern"
          layout="fill"
          objectFit="cover"
        />
      </div>

      {/* Hero Content */}
      <div className="max-w-6xl mx-auto relative z-10">
        {/* Animated Heading */}
        <motion.h1
          className="text-5xl md:text-6xl font-extrabold text-white leading-tight drop-shadow-lg"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Transform Your NEET Journey with Expert Guidance
        </motion.h1>

        {/* Subheading */}
        <motion.p
          className="mt-4 text-lg text-white max-w-3xl mx-auto leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          At <span className="font-semibold text-[#FF914D]">NEET Support</span>, we simplify the complex NEET admission process 
          with personalized counseling, AI-powered tools, and expert mentorship.
        </motion.p>

        {/* CTA Button with Glow Effect */}
        {/* <motion.div
          className="mt-6"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Link href="/contact" className="px-8 py-4 bg-[#FF914D] text-white rounded-full text-lg font-semibold shadow-lg hover:shadow-[0_0_20px_#FF914D] transition-all duration-300 transform hover:scale-105">
            Get Expert Help
          </Link>
        </motion.div> */}

        {/* Services Section with Aligned Cards */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[ 
            { icon: <FaUserGraduate className="text-5xl text-[#FF914D] mx-auto" />, title: "Counseling Guidance", description: "Step-by-step assistance for AIQ & state quota admissions." },
            { icon: <FaChalkboardTeacher className="text-5xl text-[#FF914D] mx-auto" />, title: "Expert Mentorship", description: "Personalized strategy sessions to maximize your chances." },
            { icon: <FaBook className="text-5xl text-[#FF914D] mx-auto" />, title: "College Predictor", description: "AI-powered tool to estimate your best college options." },
            { icon: <FaUniversity className="text-5xl text-[#FF914D] mx-auto" />, title: "Admission Support", description: "Complete help with documents, form filling, and college selection." }
          ].map((service, index) => (
            <motion.div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-all duration-300 transform hover:scale-105 flex flex-col justify-center items-center h-[260px]"
              whileHover={{ scale: 1.05 }}
            >
              {service.icon}
              <h3 className="text-xl font-semibold text-[#005F59] mt-4">{service.title}</h3>
              <p className="text-gray-700 mt-2 text-center">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Floating Icons for Interactive Feel */}
      <motion.div
        className="absolute top-10 left-10 text-[#FF914D] opacity-50"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      >
        <FaUserGraduate size={50} />
      </motion.div>

      <motion.div
        className="absolute bottom-10 right-10 text-[#FF914D] opacity-50"
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      >
        <FaBook size={50} />
      </motion.div>

      {/* Light Effect for Premium Look */}
      <div className="absolute top-0 left-0 w-full h-full bg-white opacity-5 pointer-events-none"></div>
    </section>
  );
};

export default HeroSection;
